export default __webpack_public_path__ + "static/21-9 v3-4a7cb4bf78bf80c292a7ab62f79ec394.mp4";